import apm from './apm/integration';
import cduUser from './cduUser';
import codelist from './codelist';
import reactRedux from './react-redux';
import versionInfo from './versionInfo/versionInfo';
export const stateManagementSlice = {
    stateManagement: {
        ...codelist,
        ...apm,
        ...reactRedux,
        ...versionInfo,
        ...cduUser
    }
};
